// eslint-disable-next-line import/no-extraneous-dependencies
import $ from 'jquery';
import Swiper from 'swiper/bundle';
import { swiperOptions, initResponsiveSwiper } from './module/SwiperFunctions';

$(() => {
  // 各エリアのチェックボックスが選択された場合、全てのチェックをOff、
  // または全て手動でチェックされた場合は「全て」のチェックボックをOnにする
  function switchAreaAllCheckbox() {
    // 全てのチェックを外す
    $('input[name="feature_area_id[all]"]').prop('checked', false);
    // 全て手動でチェックされた場合、チェックボックスの「全て」にチェックをつける
    if ($('input[name="q[areas_id_in][]"]:checked').length === $('input[name="q[areas_id_in][]"]').length - 1) {
      $('input[name="feature_area_id[all]"]').prop('checked', true);
    }
  }

  function switchTagAllCheckbox() {
    // 全てのチェックを外す
    $('input[name="feature_tag_id[all]"]').prop('checked', false);
    // 全て手動でチェックされた場合、チェックボックスの「全て」にチェックをつける
    if ($('input[name="q[tags_id_in][]"]:checked').length === $('input[name="q[tags_id_in][]"]').length - 1) {
      $('input[name="feature_tag_id[all]"]').prop('checked', true);
    }
  }

  if ($('#feature_search').length) {
    // エリア全て選択時、エリアの状態も変更する
    $('input[name="feature_area_id[all]"]').click((e) => {
      $('input[name="q[areas_id_in][]"]').prop('checked', e.target.checked);
    });

    // エリア選択の場合、全ての選択状態を設定/解除を行う
    $('input[name="q[areas_id_in][]"]').click(() => {
      switchAreaAllCheckbox();
    });

    // カテゴリー全て選択時、カテゴリーの状態も変更する
    $('input[name="feature_tag_id[all]"]').click((e) => {
      $('input[name="q[tags_id_in][]"]').prop('checked', e.target.checked);
    });

    // カテゴリー選択の場合、全ての選択状態を設定/解除を行う
    $('input[name="q[tags_id_in][]"]').click(() => {
      switchTagAllCheckbox();
    });
  }

  // /features/[:id]
  const initializeAllThemeSwipers = (swiperDataRole, paginationDataRole) => {
    const swiperElements = document.querySelectorAll(`[data-role="${swiperDataRole}"]`);
    const paginationElements = document.querySelectorAll(`[data-role="${paginationDataRole}"]`);

    swiperElements.forEach((swiperElement, index) => {
      const paginationElement = paginationElements[index];
      if (!swiperElement || !paginationElement) return;

      new Swiper(
        swiperElement,
        swiperOptions({
          slidesPerView: 1,
          pagination: {
            el: paginationElement,
            clickable: true,
          },
        })
      );
    });
  };

  // feature/:idのmv
  if (document.querySelector('[data-role="show-feature-swiper"]')) {
    new Swiper(
      '[data-role="show-feature-swiper"]',
      swiperOptions({
        slidesPerView: 1,
        spaceBetween: 16,
        centeredSlides: true,
        navigation: {
          nextEl: '.showArticle__mainViewSwiperContainer .u-articleSwiperButton--next',
          prevEl: '.showArticle__mainViewSwiperContainer .u-articleSwiperButton--prev',
        },
        pagination: {
          el: '.showArticle__mainViewPagination',
          bulletClass: 'showArticle__swiperPaginationBullet',
          bulletActiveClass: 'showArticle__swiperPaginationBullet--active',
          clickable: true,
        },
      })
    );
  }

  // すべてのSwipersを初期化する
  initializeAllThemeSwipers('single-post-swiper', 'single-post-swiper-pagination');
  // initializeAllThemeSwipers('single-theme-swiper', 'single-theme-swiper-pagination');

  // 関連スポットのsp用スライダー
  const relatedArticleSwiperElement = document.querySelectorAll('[data-role="related-article-swiper"]');

  if (relatedArticleSwiperElement.length > 0) {
    relatedArticleSwiperElement.forEach((swiperElement) => {
      const options = swiperOptions({
        slidesPerView: 1,
        navigation: {
          nextEl: '.u-swiperButton--next',
          prevEl: '.u-swiperButton--prev',
        },
        breakpoints: {
          424: {
            slidesPerView: 2,
            spaceBetween: 32,
          },
        },
      });

      initResponsiveSwiper(swiperElement, options);
    });
  }
});
